const dns_template = {
	dialog_add_template: {
		description:
			"Voeg hier een nieuw DNS template toe. Na het toevoegen kunt u de template vullen.",
		input_description: {
			label: "Omschrijving DNS-template",
			placeholder: "Geef de template optioneel een beschrijving",
		},
		input_name: {
			label: "Naam DNS-template",
			placeholder: "Bijvoorbeeld 'template-webserver'",
		},
		messages: {
			success: "DNS-template <strong>{{name}}</strong> is succesvol aangemaakt!",
		},
		title: "DNS template toevoegen",
	},
	dialog_delete_template: {
		description: "Weet je zeker dat je template <strong>{{name}}</strong> wilt verwijderen?",
		messages: {
			success: "DNS-template <strong>{{name}}</strong> is succesvol verwijderd!",
		},
		title: "DNS template verwijderen",
	},

	/* -------------------------------------------------------------------------- */
	/*                                  DNS TABLE                                 */
	/* -------------------------------------------------------------------------- */
	dns_table: {},

	/* -------------------------------------------------------------------------- */
	/*                        DNS TEMPLATE MANAGEMENT PAGE                        */
	/* -------------------------------------------------------------------------- */
	management: {
		buttons: {
			add_record: "Regel toevoegen",
			choose_template: "Template records kiezen",
			remove_default: "Ingesteld als standaard",
			retrieve_dns: "DNS records importeren",
			set_as_default: "Instellen als standaard",
		},
		form: {
			description: "Omschrijving",
			name: "Naam",
		},
		information:
			"Met DNS Templates kunt je gemakkelijk DNS-records aanmaken voor je domeinen. Je kunt deze templates gebruiken bij het aanmaken van een nieuw domein, of om DNS-records te beheren voor bestaande domeinen.",
		messages: {
			set_as_default_selected: "DNS-records geactiveerd als standaard",
			set_as_default_unselected: "DNS-records gedeactiveerd als standaard",
			success: "DNS-template <strong>{{name}}</strong> is succesvol gewijzigd!",
		},
		sure_to_leave:
			"Weet je zeker dat je de pagina wilt verlaten?\nNiet-opgeslagen wijzigingen gaan verloren.",
		tooltips: {
			choose_template:
				"Met deze knop kunt u DNS-records selecteren van één van uw andere DNS templates om deze toe te voegen aan de huidige DNS-records lijst.",
			retrieve_dns:
				"Met deze knop kunt u DNS-records ophalen van een bestaande domeinnaam, en kiezen welke DNS-records u wil importeren om in de huidige DNS-records lijst te gebruiken.",
			set_as_default:
				"Met deze knop kan je de huidige DNS template als standaard instellen. Dit betekent dat deze template automatisch geselecteerd wordt tijdens het aanmaken van een nieuw domein, en dus handig is wanneer je vaak deze template kiest tijdens het aanmaken van een domein.",
		},
	},
	/* -------------------------------------------------------------------------- */
	/*                                OVERVIEW PAGE                               */
	/* -------------------------------------------------------------------------- */
	overview: {
		table: {
			default: "Standaard",
			description: "Omschrijving",
			label: "Label",
		},
		title: "DNS templates",
	},
};

export default dns_template;
